
































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { Story } from "@scrile/api-provider/dist/projects/scrileConnect/StoriesProvider";
import { isMediaFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { formatMoneyString } from "@/lib/moneyHelpers";
import { formatDate } from "@/lib/time";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";

export default defineComponent({
  name: "StoriesArchiveCard",
  components: { BaseIcon, BaseImage },
  props: {
    story: { type: Object as PropType<Story>, required: true },
  },
  setup(props) {
    const defaultMediaPreview = "/img/content-preview-media.svg";
    const coverFile = props.story.contentFeed?.files.find(f => isMediaFile(f));
    const method = (coverFile && isVideoFile(coverFile) && "getVideoThumbnail") || "getImageThumbnail";
    const coverSrc = !coverFile ? "" : MediaFilesController[method](coverFile.urlPart, "480p");

    const storyOverlaySrc = computed(
      () => (!!props.story.overlay && MediaFilesController.getFileUrl(props.story.overlay.urlPart)) || ""
    );
    const publishTime = computed(() =>
      formatDate(new Date(props.story.contentFeed?.publishTime || ""), {
        month: "short",
        day: "numeric",
      })
    );

    const likesCount = computed(() => props.story.statistic?.likeCount);
    const viewsCount = computed(() => props.story.statistic?.viewCount);
    const tipAmount = computed(() => formatMoneyString(props.story.statistic?.tipAmount ?? 0));
    const storyCover = computed(() => coverSrc || defaultMediaPreview);

    return {
      publishTime,
      storyCover,
      coverSrc,
      likesCount,
      viewsCount,
      tipAmount,
      storyOverlaySrc,
    };
  },
});
